import { postCall } from 'sharedKernel/api'
import { PUBLIC_MEETING_ROOM_API } from './constants'

export interface IPublicReservationPayload {
  meetingRoomId: string
  name: string
  email: string
  phone: string
  companyName: string
  reservationDate: string
  endDate: string
  startTime: string
  endTime: string
  institutionType: string
  eventName: string
  eventDescription: string
  numberAttendees: number
  isPublic: boolean
  promoteOnWebsite: boolean
  questionAnswers?: Array<{ questionId: string; answer: string }>
}

export interface IPublicReservationResponse {
  id: string
  cancelToken: string
  code: string
}

export const submitPublicReservation = async (
  payload: IPublicReservationPayload
): Promise<IPublicReservationResponse> => {
  const response = await postCall({
    url: PUBLIC_MEETING_ROOM_API.SAVE_RESERVATION,
    isPublic: true,
    data: payload,
  })
  const data = response.data?.data ?? response.data
  return {
    id: String(data?.id ?? ''),
    cancelToken: String(data?.cancelToken ?? ''),
    code: String(data?.code ?? data?.solicitationNumber ?? data?.protocol ?? ''),
  }
}

export const submitPublicReservationForRooms = async (
  roomIds: string[],
  payload: Omit<IPublicReservationPayload, 'meetingRoomId'>
): Promise<IPublicReservationResponse[]> => {
  return Promise.all(
    roomIds.map(meetingRoomId => submitPublicReservation({ ...payload, meetingRoomId }))
  )
}
